import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import Modal from '../../../../../components/modal/index';
import TagInput from '../../../../../components/form/tag-input';
import { Formik } from 'formik';
import * as Yup from "yup";
import { getActiveBanks, mccBulkUpdate } from '../../../../../../api';
import ButtonIcon from '../../../../../components/ButtonIcon/ButtonIcon';
import useMccStore from '../../../../../stores/mcc';
import toast from 'react-hot-toast';

const schema = Yup.object().shape({
  banks: Yup.array().min(1, "* Please select at least 1 bank"),
});

const RemoveProcessorUpdate = ({ isOpen, onClose, fetchData }) => {

  const selectedMcc = useMccStore((state) => state.selectedMcc);
  const setSelectedMcc = useMccStore((state) => state.setSelectedMcc);

  const [is_submitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    banks: [],
  });

  const [bankOptions, setBankOptions] = useState([]);

  useEffect(() => {
    if (isOpen) {
      const fetchBanks = async () => {
        try {
          const res = await getActiveBanks();
          if (res.status) {
            const banks = res.data.map((item) => ({
              value: item.id,
              label: item.name,
            }));
            setBankOptions(banks);
          }
        } catch (error) {
          setBankOptions([]);
        }
      };


      fetchBanks();
    }
  }, [isOpen]);


  const onSubmit = async (values) => {
    const toastId = toast.loading('Updating...');
    let data = {
      mcc: selectedMcc,
      remove_processor: true,
      bank: values.banks,
    };
    const response = await mccBulkUpdate(data);
    if (response?.success) {
      fetchData();
      setSelectedMcc([]);
      toast.success("Removed successfully", { id: toastId, duration: 5000 });
      onClose();
    } else {
      toast.error("Failed to remove processor", { id: toastId, duration: 5000 });
      setSelectedMcc([]);
      onClose();
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} header={"Remove Processors"}>
      <Formik
        enableReinitialize
        validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={formData}
        validateOnBlur={false}
        validateOnChange={is_submitted}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          touched,
          errors,
          setFieldValue,
          isSubmitting,
        }) => (
          <form
            onSubmit={handleSubmit}
            autoComplete="off"
            className={styles.container}
          >
            <div className={styles.formGroup}>
              <p className={styles.formLabel}>Banks</p>
              <TagInput
                id={"banks"}
                name={"banks"}
                options={bankOptions}
                value={values.banks}
                onChange={(value) => {
                  console.log("value :>> ", value);
                  setFieldValue("banks", value);
                }}
                error={errors.banks}
                errored={errors.banks}
                touched={touched.banks}
                placeholder={"Search"}
              />
            </div>

            <div className={styles.footer}>
              <ButtonIcon
                bgColor={"#FFF"}
                textColor="#254FE2"
                onClick={onClose}
                type="button"
              >
                Cancel
              </ButtonIcon>

              <ButtonIcon bgColor={"#4C70EF"} textColor="#FFF" type="submit">
                Remove for {selectedMcc?.length || 0} codes
              </ButtonIcon>
            </div>
          </form>
        )}
      </Formik>
    </Modal>
  );
}

export default RemoveProcessorUpdate